import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Avatar, Badge } from '@mui/material';

import Button from 'app/ui-kit/components/Button';
import useStores from 'hooks/use-stores';
import { useMenuContext } from 'pages/layout/components/MenuContext';

import useStyles from './styles';

const AuthButton = ({ className }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const { userStore } = useStores();
    const { adaptive } = useMenuContext();

    const initials = userStore.user.fullName
        .split(' ')
        .map((name) => name[0])
        .join('')
        .toUpperCase();

    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);
    const goToLogin = useCallback(() => history.push('/login'), [history]);

    if (userStore.isLoading) {
        return null;
    }

    if (!userStore.isAuthorized) {
        return <Button text="SIGN IN" onClick={goToLogin} className={cx(classes.signIn, className)} />;
    }

    return (
        <div
            className={cx(classes.container, { [classes.containerAdaptive]: adaptive }, className)}
            onClick={goToUserInfo}
        >
            <Badge
                overlap="circular"
                badgeContent={<ArrowUpwardIcon className={classes.badgeIcon} />}
                classes={{ badge: classes.badge }}
                invisible={userStore.hasLicense}
            >
                <Avatar className={classes.avatar}>{initials}</Avatar>
            </Badge>
            <div className={cx(classes.textContainer, { [classes.textContainerAdaptive]: adaptive })}>
                <span className={classes.userName}>{userStore.user.fullName}</span>
                <span className={classes.creditsLabel}>
                    {`Credits left `}
                    <span className={classes.creditsCount}>{userStore.userCredits}</span>
                </span>
            </div>
        </div>
    );
};

AuthButton.propTypes = {
    className: PropTypes.string
};

export default observer(AuthButton);
